import PagesFiltersToolsBar from "./PagesFiltersToolsBar";

export default PagesFiltersToolsBar;